export enum VisibilityGrid {
    AlwaysOn = 'alwayson',
    Visible = 'visible',
    Hidden = 'hidden'
}
